import React from 'react';
import ExternalShareContentRenderer from '@confluence-classic/confluence-fabric-editor/src/components/ExternalShareContentRenderer/index.ts';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { getUniquePageLoadId } from '@confluence/unique-page-load-id/entry-points/UniquePageLoadId.ts';
import { expVal } from '@confluence/feature-experiments';
import { LoadablePaint } from '@confluence/loadable';
import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';
import { ShareableLinksMainLayout } from '@confluence/main-layout/entry-points/ShareableLinksMainLayout.ts';

const ShareableLinkLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExternalShareRouteComponent" */ '@confluence/external-share/entry-points/ExternalSharePage.ts'
			)
		).ExternalSharePage,
});

export const ShareableLinkRoute = ({ params: { shareToken }, hash }: RouteMatch) => {
	if (!expVal('shareable_links_m0', 'isEnabled', false)) {
		return <NotFound />;
	}
	return (
		<ShareableLinksMainLayout>
			<ShareableLinkLoader
				siteUrl={window.location.hostname}
				shareToken={shareToken}
				queryHash={hash}
				ContentRenderer={ExternalShareContentRenderer}
			/>
		</ShareableLinksMainLayout>
	);
};

ShareableLinkRoute.NAVIGATION_PARAMS = ({ name }: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'viewPageScreen',
			attributes: {
				isPublicView: true,
				isShareableLinkView: true,
				pageLoadInfo: getUniquePageLoadId(),
			},
		},
		pageState: {
			routeName: name,
		},
	},
	MainLayout: false,
	BannerContext: { includeTopNav: false },
});
